module.exports = __webpack_public_path__ + "static/pb-logo-1e9d43c9eff571160b442ffe36fb7246.svg";